var mp = mp || {};

// User info
//----------------------------------------------------------
mp.formValidationUserInfo = function() {
    var $element = $('#ValidateForm__UserInfo');

    if (!$element.length) {
        return;
    }

    $element.validate({
        //errorPlacement: function(error, element) {},
        rules: {
            "ime_prezime": {
                required: true,
                minlength: 4
            },
            "datum_rodjenja": {
                required: true,
            },
            "telefon": {
                required: true,
                minlength: 6
            },
            "adresa": {
                required: true,
            },
            "grad": {
                required: true,
            },
            "postanski_broj": {
                required: true,
                digits: true,
                minlength: 5,
                maxlength: 5
            },
            "oib": {
                required: true,
                digits: true,
                minlength: 11,
                maxlength: 11
            },
            "fakultet_ime": {
                required: true,
            },
            "prebivaliste_adresa": {
                required: true,
            },
            "prebivaliste_grad": {
                required: true,
            },
            "prebivaliste_postanski_broj": {
                required: true,
                digits: true,
                minlength: 5,
                maxlength: 5
            },
            "dostava_adresa": {
                required: true,
            },
            "dostava_grad": {
                required: true,
            },
            "dostava_postanski_broj": {
                required: true,
                digits: true,
                minlength: 5,
                maxlength: 5
            },
            "dostava_ime_kaslic": {
                required: true,
            },
            "dostava_ime_vrata": {
                required: true,
            },
            "agree": {
                required: true,
            }
        }
    });
};


$(document).ready(function (){
    mp.formValidationUserInfo();
});